import { createPlugin, createApiFactory, storageApiRef, identityApiRef, createRoutableExtension, createComponentExtension } from '@backstage/core-plugin-api';
import { createCardExtension } from '@backstage/plugin-home-react';
import { rootRouteRef } from './routes.esm.js';
import { VisitsStorageApi } from './api/VisitsStorageApi.esm.js';
import '@backstage/core-app-api';
import { visitsApiRef } from './api/VisitsApi.esm.js';

const homePlugin = createPlugin({
  id: "home",
  apis: [
    createApiFactory({
      api: visitsApiRef,
      deps: {
        storageApi: storageApiRef,
        identityApi: identityApiRef
      },
      factory: ({ storageApi, identityApi }) => VisitsStorageApi.create({ storageApi, identityApi })
    })
  ],
  routes: {
    root: rootRouteRef
  }
});
const HomepageCompositionRoot = homePlugin.provide(
  createRoutableExtension({
    name: "HomepageCompositionRoot",
    component: () => import('./components/index.esm.js').then((m) => m.HomepageCompositionRoot),
    mountPoint: rootRouteRef
  })
);
const ComponentAccordion = homePlugin.provide(
  createComponentExtension({
    name: "ComponentAccordion",
    component: {
      lazy: () => import('./componentRenderers/index.esm.js').then((m) => m.ComponentAccordion)
    }
  })
);
const ComponentTabs = homePlugin.provide(
  createComponentExtension({
    name: "ComponentTabs",
    component: {
      lazy: () => import('./componentRenderers/index.esm.js').then((m) => m.ComponentTabs)
    }
  })
);
const ComponentTab = homePlugin.provide(
  createComponentExtension({
    name: "ComponentTab",
    component: {
      lazy: () => import('./componentRenderers/index.esm.js').then((m) => m.ComponentTab)
    }
  })
);
const WelcomeTitle = homePlugin.provide(
  createComponentExtension({
    name: "WelcomeTitle",
    component: {
      lazy: () => import('./homePageComponents/WelcomeTitle/index.esm.js').then((m) => m.WelcomeTitle)
    }
  })
);
const HomePageCompanyLogo = homePlugin.provide(
  createComponentExtension({
    name: "CompanyLogo",
    component: {
      lazy: () => import('./homePageComponents/CompanyLogo/index.esm.js').then((m) => m.CompanyLogo)
    }
  })
);
const HomePageRandomJoke = homePlugin.provide(
  createCardExtension({
    name: "HomePageRandomJoke",
    title: "Random Joke",
    components: () => import('./homePageComponents/RandomJoke/index.esm.js'),
    description: "Shows a random joke about optional category",
    layout: {
      height: { minRows: 4 },
      width: { minColumns: 3 }
    },
    settings: {
      schema: {
        title: "Random Joke settings",
        type: "object",
        properties: {
          defaultCategory: {
            title: "Category",
            type: "string",
            enum: ["any", "programming", "dad"],
            default: "any"
          }
        }
      }
    }
  })
);
const HomePageToolkit = homePlugin.provide(
  createCardExtension({
    name: "HomePageToolkit",
    title: "Toolkit",
    components: () => import('./homePageComponents/Toolkit/index.esm.js')
  })
);
const HomePageStarredEntities = homePlugin.provide(
  createCardExtension({
    name: "HomePageStarredEntities",
    title: "Your Starred Entities",
    components: () => import('./homePageComponents/StarredEntities/index.esm.js')
  })
);
const HeaderWorldClock = homePlugin.provide(
  createComponentExtension({
    name: "HeaderWorldClock",
    component: {
      lazy: () => import('./homePageComponents/HeaderWorldClock/index.esm.js').then(
        (m) => m.HeaderWorldClock
      )
    }
  })
);
const HomePageTopVisited = homePlugin.provide(
  createCardExtension({
    name: "HomePageTopVisited",
    title: "Top Visited",
    components: () => import('./homePageComponents/VisitedByType/TopVisited.esm.js')
  })
);
const HomePageRecentlyVisited = homePlugin.provide(
  createCardExtension({
    name: "HomePageRecentlyVisited",
    title: "Recently Visited",
    components: () => import('./homePageComponents/VisitedByType/RecentlyVisited.esm.js')
  })
);
const FeaturedDocsCard = homePlugin.provide(
  createCardExtension({
    name: "FeaturedDocsCard",
    title: "Featured Docs",
    components: () => import('./homePageComponents/FeaturedDocsCard/index.esm.js')
  })
);

export { ComponentAccordion, ComponentTab, ComponentTabs, FeaturedDocsCard, HeaderWorldClock, HomePageCompanyLogo, HomePageRandomJoke, HomePageRecentlyVisited, HomePageStarredEntities, HomePageToolkit, HomePageTopVisited, HomepageCompositionRoot, WelcomeTitle, homePlugin };
//# sourceMappingURL=plugin.esm.js.map
